import React from 'react'
import {
  FormDashboardLabel as Label,
} from '../'
import {
  LocationTable,
  LocationPopup,
} from '.'
import { Plus } from 'react-feather'
import { useViewport } from '../../utils'
import DevLogger from '../_dev-logger'
import { ArrayChecker } from '../array-checker'
import { addToHolder } from '../../features/program-form/slice'
import { useDispatch } from 'react-redux'
import { useInternationalization } from '../../features/i18n'

const LocationAdder = ({data, onChange}) => {
  const dispatch = useDispatch()
  const { isMobile } = useViewport()
  const [isAdding, setIsAdding] = React.useState(false)
  const [isEditing, setIsEditing] = React.useState(false)
  const [locationToEdit, setLocationToEdit] = React.useState({})
  const [locationToEditIndex, setLocationToEditIndex] = React.useState(null)
  const { translate } = useInternationalization()

  const handleAddLocation = (location) => {
    const id = 'NEW_'+String(Math.random())

    dispatch(addToHolder({entity: 'location', type: 'create', id}))

    const withId = {...location}
    withId.pkId = id

    onChange([
      ...data,
      withId
    ])
    setIsAdding(false)
  }

  const handleEditLocation = (location) => {
    const newData = data.map((l, i) => {
      if(i === locationToEditIndex){
        return location
      }
      return l
    })
    onChange(newData)
    setIsEditing(false)
  }

  const handleEditTrigger = (location, index) => {
    setLocationToEdit(location)
    setLocationToEditIndex(index)
    setIsEditing(true)
  }

  const handleDelete = (location, index) => {
    dispatch(addToHolder({entity: 'location', type: 'delete', id: location.pkId}))

    const newData = data.filter((l, i) => i !== index)
    onChange(newData)
    setIsEditing(false)
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-3 lg:mb-5">
        <Label noMargin>{translate('GENERAL', 'location_plural')}</Label>
        <div
          className="text-sm text-primary flex items-center cursor-pointer whitespace-no-wrap"
          onClick={() => setIsAdding(true)}
        >
          <Plus className="lg:mr-1" style={{width: isMobile ? '18px' : '14px'}}/>
          <p className="whitespace-no-wrap">Add <span className="hidden lg:inline">Location</span></p>
        </div>
      </div>

      <DevLogger data={data}/>

      <ArrayChecker data={data}>
        <div className="mobile-fullwidth">
          <LocationTable
            data={data}
            onEdit={(d, index) => handleEditTrigger(d, index)}
            onDelete={(d, index) => handleDelete(d, index)}
          />
        </div>
      </ArrayChecker>
      {
        isAdding &&
        <LocationPopup title="Add Location" onClose={setIsAdding} onSave={handleAddLocation}/>
      }
      {
        isEditing &&
        <LocationPopup title="Edit Location" onClose={setIsEditing} onSave={handleEditLocation} locationToEdit={locationToEdit}/>
      }
    </div>
  )
}

export { LocationAdder }
